import store from './store'

// 获取所有地区下拉
const getSmsAreaCodesQuery = async () => {
  store.dispatch('global/getSmsAreaCodes')
}

// 获取所有邮箱下拉
const getMailSuffixesQuery = async () => {
  store.dispatch('global/getMailSuffixesList')
}

// 获取动态配置的H5网址
export const getDynamicH5Url = async () => {
  store.dispatch('global/getDynamicH5Url')
}

const globalQuery = () => {
  getSmsAreaCodesQuery()
  getMailSuffixesQuery()
  getDynamicH5Url()
}
export default globalQuery
